import { render, staticRenderFns } from "./ItemDialog.vue?vue&type=template&id=f62bef3a"
import script from "./ItemDialog.vue?vue&type=script&lang=js"
export * from "./ItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports